// src/pages/Checklist.jsx

export default function Checklist() {
    return (
      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-semibold">Checklist</h1>
  
        {/* Daily Checklist */}
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <h2 className="text-lg font-semibold mb-4">Daily Checklist</h2>
  
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Review team attendance
            </li>
  
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Approve pending leave requests
            </li>
  
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Check HR updates
            </li>
  
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Review new employee tasks
            </li>
          </ul>
        </div>
  
        {/* Monthly Checklist */}
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <h2 className="text-lg font-semibold mb-4">Monthly Checklist</h2>
  
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Performance review summaries
            </li>
  
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Update team goals
            </li>
  
            <li className="flex items-center gap-3">
              <input type="checkbox" className="w-5 h-5" />
              Payroll verification
            </li>
          </ul>
        </div>
      </div>
    );
  }
  